{
  "show": {
    "title": "Go Live",
    "empty_list_description": "None of your classes have been allocated yet.",
    "empty_list_title": "No Priorities Can Go Live",
    "allocated_one": "{{count}} student allocated.",
    "allocated_other": "{{count}} students allocated.",
    "requests_to_leave_one": "{{count}} request to leave.",
    "requests_to_leave_other": "{{count}} requests to leave.",
    "requests_to_join_one": "{{count}} request to join.",
    "requests_to_join_other": "{{count}} requests to join.",
    "actions.go_live": "Go Live",
    "status_true": "Live",
    "status_false": "Not Live",
    "priority_rank": "Priority: {{rank}}",
    "capacity": "Capacity: {{maximum}}",
    "minimum_label": "Min: {{minimum}}",
    "maximum_label": "Max: {{maximum}}",
    "allocated_label": "Allocated:",
    "minimum_footer_label": "Minimum:",
    "maximum_footer_label": "Maximum:",
    "go_live": {
      "init_description": "This action cannot be undone. you must provide teaching services at the agreed upon dates and times for the duration of the class.",
      "pending_description": "Going Live...",
      "success_description": "This class has gone live",
      "error_description": "Please refresh and try again."
    }
  }
}
